import { marked, type Token, type Tokens } from "marked";

export interface PracticeSection {
    title: string;
    question: string;
    body: string;
}

export function sentenceCaseHeading(text: string): string {
    if (text !== text.toLocaleUpperCase()) {
        return text;
    }
    const lower = text.toLocaleLowerCase();
    return lower.charAt(0).toLocaleUpperCase() + lower.slice(1);
}

export function practiceSections(markdown: string): PracticeSection[] {
    const tokens = marked.lexer(markdown);
    // Reference definitions are document-wide; keep that scope intact when present.
    if (Object.keys(tokens.links).length) {
        return [{ title: "", question: "", body: markdown }];
    }
    const groups: Token[][] = [[]];
    for (const token of tokens) {
        if (token.type === "hr") {
            groups.push([]);
        } else {
            groups.at(-1)!.push(token);
        }
    }
    return groups
        .filter((group) => group.some((token) => token.type !== "space"))
        .map((group) => {
            const titleIndex = group.findIndex((token) => token.type === "heading" && token.depth <= 3);
            if (titleIndex < 0 || group.slice(0, titleIndex).some((token) => token.type !== "space" && token.type !== "heading")) {
                return { title: "", question: "", body: group.map((token) => token.raw).join("") };
            }
            const title = group[titleIndex] as Tokens.Heading;
            const question = group
                .slice(0, titleIndex)
                .filter((token): token is Tokens.Heading => token.type === "heading")
                .map((token) => sentenceCaseHeading(token.text))
                .join(" ");
            return {
                title: title.text,
                question,
                body: group
                    .slice(titleIndex + 1)
                    .map((token) => token.raw)
                    .join("")
                    .trim(),
            };
        });
}
